<script lang="typescript">
    import { state } from "./stores";
    import { activePromotions, eyecarePlanDiscount } from "./offers";
    import { Promotion } from "./types";
    import { onMount, tick } from "svelte";

    export let hidePromo: boolean = false;

    let promotions = [];

    onMount(async () => {
        await tick();
        promotions = activePromotions($state);
    });
</script>

<div class="absolute bottom-8 w-full z-10 flex items-end space-x-5 px-5">
    {#if !hidePromo}
        {#if promotions.includes(Promotion.EYECARE_PLAN)}
            <div class="features bg-white rounded-sm">
                <div class="m-4 text-black">
                    <h2>Features & benefits</h2>
                    <ul class="">
                        <li>
                            {eyecarePlanDiscount($state).toLocaleString(undefined, {
                                style: "percent",
                            })} discount
                        </li>
                        <li>Accidental breakage & loss protection (optional)</li>
                        <li>Free routine eye tests</li>
                        <li>Free reglaze</li>
                        <li>Free 100 day returns guarantee</li>
                        <li>Free lifetime servicing</li>
                    </ul>
                </div>
                <div class="bg-primary text-white rounded-md text-center m-4 p-4">
                    Have you asked our team about our eye care plan?
                </div>
            </div>
        {/if}
    {/if}
    <div class="flex flex-grow justify-end space-x-5">
        <img src="/img/100-day-returns-guarantee.png" alt="" class="w-24" />
        <img src="/img/optical-experts.png" alt="" class="w-24" />
        <img src="/img/free-lifetime-servicing.png" alt="" class="w-24" />
    </div>
</div>
